import React from "react";
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort';
import { findArray, filterArray } from 'helpers/utils';
import Noc from 'components/presentation/Noc';
import Label from "components/general/Label";
import SportCode from "components/common/SportCode";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import NotAvailable from "components/common/NotAvailable";

const ResultsTable = ({ results }) => {
    const { breakPoint } = useViewport();
    const { mirs_discipline } = useUrlFriendlyToParameters()
    let matches = filterArray(results?.extendedInfos, { ei_type: ['BOUT'], ei_code: ['BONUS'] })
    let currentBout = findArray(results?.extendedInfos, { ei_code: ['BOUT_CURRENT'] })?.ei_value
    if (!matches) return <NotAvailable />

    if (breakPoint === 'sm' || breakPoint === 'xs') {
        return (
            <>
                <table className="table table-detail">
                    <thead>
                        <tr>
                            <th scope="col" className="text-start align-middle w-25"><Label data={'HeaderName'} /></th>
                            <th scope="col" colSpan={3} className="text-center align-middle w-20"><Label data={'HeaderResult'} /></th>
                            <th scope="col" className="text-start align-middle w-25"><Label data={'HeaderName'} /></th>
                        </tr>
                    </thead>
                    <tbody>
                        {matches.map((m, index) => {
                            //Athletes
                            let athlete1Code = findArray(m?.extensions, { eie_pos: ['1'] })?.eie_value
                            let athlete2Code = findArray(m?.extensions, { eie_pos: ['2'] })?.eie_value
                            let athlete1 = results?.items?.find(a => a.participant.code === athlete1Code)
                            let athlete2 = results?.items?.find(a => a.participant.code === athlete2Code)
                            //Data
                            let bout = m?.ei_pos
                            let resultAthlete1 = findArray(findArray(athlete1?.extendedResults, { er_code: ['BOUTS'], er_value: [bout] })?.extensions, { ere_code: ['RESULT'] })?.ere_value
                            let resultAthlete2 = findArray(findArray(athlete2?.extendedResults, { er_code: ['BOUTS'], er_value: [bout] })?.extensions, { ere_code: ['RESULT'] })?.ere_value
                            return (
                                <>
                                    <tr key={`mpn-fencing-rr-results-${index}`} style={currentBout === bout ? { backgroundColor: "#ffc107" } : {}}>
                                        <td className="text-start">
                                            <Competitor {...athlete1?.participant} hidePicture={true} />
                                        </td>
                                        <td className="text-center fw-bold">{resultAthlete1}</td>
                                        <td className="text-center fw-bold">-</td>
                                        <td className="text-center fw-bold">{resultAthlete2}</td>
                                        <td className="text-start">
                                            {athlete2
                                                ? <>
                                                    <Competitor {...athlete2?.participant} hidePicture={true} />
                                                </>
                                                : <><SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={athlete2Code} /></>}
                                        </td>
                                    </tr>
                                </>
                            )
                        })
                        }
                    </tbody>
                </table>
            </>
        )
    }
    else return (
        <>
            <table className="table table-detail">
                <thead>
                    <tr>
                        <th scope="col" className="text-center align-middle w-5"><Label data={'HeaderBout'} /></th>
                        <th scope="col" className="text-end w-5"><Label data={'HeaderBibNoR'} /></th>
                        <th scope="col" className="text-start align-middle w-25"><Label data={'HeaderName'} /></th>
                        <th scope="col" colSpan={3} className="text-center align-middle w-20"><Label data={'HeaderResult'} /></th>
                        <th scope="col" className="text-start align-middle w-25"><Label data={'HeaderName'} /></th>
                        <th scope="col" className="text-end w-5"><Label data={'HeaderBibNoR'} /></th>
                    </tr>
                </thead>
                <tbody>
                    {matches?.map((m, index) => {
                        //Athletes
                        let athlete1Code = findArray(m?.extensions, { eie_pos: ['1'] })?.eie_value
                        let athlete2Code = findArray(m?.extensions, { eie_pos: ['2'] })?.eie_value
                        let athlete1 = results?.items?.find(a => a.participant.code === athlete1Code)
                        let athlete2 = results?.items?.find(a => a.participant.code === athlete2Code)

                        let athName1= athlete1?.teamAthletes?.map((ath, i) => {
                            return (
                                <>
                                    {i!==0 && '/'}
                                    <Competitor {...ath?.athlete} hideNoc={true} hidePicture={true}/>
                                </>
                             )
                        })
                        let athName2= athlete2?.teamAthletes?.map((ath, i) => {
                            return (
                                <>
                                    {i!==0 && '/'}
                                    <Competitor {...ath?.athlete} hideNoc={true} hidePicture={true}/>
                                </>
                             )
                        })
                        //Data
                        let bout = m?.ei_pos
                        let resultAthlete1 = findArray(findArray(athlete1?.extendedResults, { er_code: ['BOUTS'], er_value: [bout] })?.extensions, { ere_code: ['RESULT'] })?.ere_value
                        let resultAthlete2 = findArray(findArray(athlete2?.extendedResults, { er_code: ['BOUTS'], er_value: [bout] })?.extensions, { ere_code: ['RESULT'] })?.ere_value
                        return (
                            <>
                                <tr key={`mpn-fencing-rr-results-${index}`} style={currentBout === bout ? { backgroundColor: "#ffc107" } : {}}>
                                    <td className="text-center">{bout}</td>
                                    <td className="text-end">{athlete1?.bib}</td>
                                    <td className="text-start d-flex flex-row">
                                        <Noc {...athlete1?.participant?.organisation} />
                                        {athName1}
                                    </td>
                                    <td className="text-center fw-bold">{resultAthlete1}</td>
                                    <td className="text-center fw-bold">-</td>
                                    <td className="text-center fw-bold">{resultAthlete2}</td>
                                    <td className={athlete2 ? "text-start d-flex flex-row" : "text-start"}>
                                        {athlete2
                                            ? <>
                                                <Noc {...athlete2?.participant?.organisation} />
                                                {athName2}
                                            </>
                                            : <><SportCode discipline={mirs_discipline} entity='@CompetitorPlace' code={athlete2Code} /></>}
                                    </td>
                                    <td className="text-end">{athlete2?.bib}</td>
                                </tr>
                            </>
                        )
                    })
                    }
                </tbody>
            </table>
        </>
    )
}

export const MpnFenBonusResults = React.memo((props) => {
    let results = props?.data
    return (
        <>
            <ResultsTable results={results} />
        </>
    )
});


export default MpnFenBonusResults